window.CardSelectorModule = (() => {
  function initalizeCardSelector() {
    // Get all elements with the class "infocard_selector-item"
    const infocardItems = document.querySelectorAll(
      ".infocard_selector-item-js"
    );
    // Find all elements with class .js-selector
    const jsSelectors = document.querySelectorAll(".js-selector");
    infocardItems.forEach((item) => {
      item.addEventListener("click", () => {
        if (item.classList.contains("selected")) {
          // If already selected, do nothing
          return;
        }
        // Remove the "selected" class from all items
        infocardItems.forEach((otherItem) => {
          otherItem.classList.remove("selected");
        });

        // Toggle the "selected" class on the clicked item
        item.classList.toggle("selected");

        // Get the ID of the clicked item
        const itemId = item.id;

        // Find the corresponding number from the ID (assuming the format is 'selector<number>')
        const itemNumber = itemId.replace("selector", "");

        if (itemNumber == "1") {
          let maincontent = document.querySelector(".main_content-image-js");
          let mainwrapper = document.querySelector(".main-content-js");
          // maincontent.style.height = "500px";
          // mainwrapper.style.height = "520px";
        } else if (itemNumber == "2") {
          let maincontent = document.querySelectorAll(
            ".main_content-image-js"
          )[1];
          let mainwrapper = document.querySelectorAll(".main-content-js")[1];
          // maincontent.style.height = "700px";
          // mainwrapper.style.height = "720px";
        } else {
          let maincontent = document.querySelectorAll(
            ".main_content-image-js"
          )[2];
          let mainwrapper = document.querySelectorAll(".main-content-js")[2];
          // maincontent.style.height = "700px";
          // mainwrapper.style.height = "720px";
        }

        // Loop through all .js-selector elements
        jsSelectors.forEach((selector) => {
          // Get the ID of the .js-selector element
          const selectorId = selector.id;

          // Check if the selector ID matches the format 'slide<number>'
          if (selectorId === "slide" + itemNumber) {
            // Toggle the .js-hidden class on the matched element
            selector.classList.toggle("js-hidden");
          } else {
            // Ensure other elements are hidden
            selector.classList.add("js-hidden");
          }
        });
      });
    });
  }

  return {
    init: initalizeCardSelector,
  };
})();

document.addEventListener("DOMContentLoaded", function () {
  window.CardSelectorModule.init();
});
